export enum TickmillCompanyTypes {
  Tickmill_EU_Company = 1,
  Tickmill_UK_Company = 2,
  Tickmill_SC_Company = 3,
  Tickmill_Partners_Company = 4,
  Tickmill_AS_Company = 5,
}

export const isTickmillCompanyEUType = (type?: TickmillCompanyTypes) => {
  return TickmillCompanyTypes.Tickmill_EU_Company === type
}

export const isTickmillCompanyUKType = (type?: TickmillCompanyTypes) => {
  return TickmillCompanyTypes.Tickmill_UK_Company === type
}

export const getTickmillCompanyNameByType = (
  type?: TickmillCompanyTypes
):
  | ''
  | 'Tickmill EU Company'
  | 'Tickmill UK Company'
  | 'Tickmill SC Company'
  | 'Tickmill AS Company'
  | 'Tickmill Partners Company' => {
  if (!type) {
    return ''
  }
  switch (type) {
    case TickmillCompanyTypes.Tickmill_EU_Company:
      return 'Tickmill EU Company'
    case TickmillCompanyTypes.Tickmill_UK_Company:
      return 'Tickmill UK Company'
    case TickmillCompanyTypes.Tickmill_SC_Company:
      return 'Tickmill SC Company'
    case TickmillCompanyTypes.Tickmill_AS_Company:
      return 'Tickmill AS Company'
    case TickmillCompanyTypes.Tickmill_Partners_Company:
      return 'Tickmill Partners Company'
    default:
      return ''
  }
}
